module.exports = __webpack_public_path__ + "static/media/mystery-vehicle.9ab28e09.jpg";